import React from 'react';
import {
  setDisplayName,
  withProps,
} from 'recompose';
import TextButton, {
  Against as TextButtonAgainst,
  Size as TextButtonSize,
} from '@ux/text-button';
import Button, {
  Kind as ButtonKind,
  Size as ButtonSize,
} from '@ux/button';
import { FormattedMessage } from 'react-intl';
import { AvailabilityStatus } from '../../../core/constants';
import { createPaintbrushUrl } from '@ux/glyphs';
import stylesheet from './Purchase.stylesheet';
import { withStyles } from '@ux/style-utils';
import { withBreakpoints } from '@ux/responsive';
import * as r from 'ramda';

export const Against = TextButtonAgainst;

export const PurePurchase = r.cond([
  [ r.propSatisfies(r.equals(AvailabilityStatus.VERIFYING), 'status'), ({
    styles,
    intlNamespace,
  }) => (
    <span style={styles.availability}>
      <FormattedMessage id={`dst.${intlNamespace}.verifying`}/>
    </span>
  ) ],
  [ r.propSatisfies(r.equals(AvailabilityStatus.AVAILABLE), 'status'), ({
    styles,
    against,
    theme,
    iconColor,
    intlNamespace,
    onViewBasketClick,
  }) => (
    <div>
      <span style={styles.availability}>
        <span style={styles.availabilityText}>
          <FormattedMessage id={`dst.${intlNamespace}.available`}/>
        </span>
      </span>
      <TextButton
        against={against}
        size={TextButtonSize.MD}
        theme={theme}
        onClick={onViewBasketClick}
        data-selector="dst-view-basket"
      >
        <FormattedMessage id={`dst.${intlNamespace}.basket`}/>
      </TextButton>
      <img
        style={styles.availabilityIcon}
        src={createPaintbrushUrl(
          'circleTick',
          [ iconColor ]
        )}
        aria-hidden="true"
        alt="tick"
      />
    </div>
  ) ],
  [ r.T, ({
    theme,
    fqdn,
    styles,
    isMinSm,
    onPurchaseDomainClick,
    intlNamespace,
  }) => (
    <Button
      theme={theme}
      kind={ButtonKind.PRIMARY}
      size={ButtonSize.MD}
      block={r.not(isMinSm)}
      onClick={onPurchaseDomainClick}
      glyph="circlePositive"
      data-selector="dst-exact-match-buy"
      data-value={fqdn}
    >
      <span style={styles.buttonText}>
        <FormattedMessage id={`dst.${intlNamespace}.buy`}/>
      </span>
    </Button>
  ) ],
]);

export const enhance = r.compose(
  setDisplayName('ExactMatchPurchase'),
  withProps((ownerProps) => ({
    iconColor: r.ifElse(
      r.propEq('against', Against.PRIMARY),
      r.path([ 'theme', 'palette', 'primaryContrast' ]),
      r.path([ 'theme', 'palette', 'green01' ]),
    )(ownerProps),
  })),
  withBreakpoints,
  withStyles(stylesheet),
);

export default enhance(PurePurchase);
